"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import GridColumn from "../common/grid-column/grid-column";
import GridRow from "../common/grid-row/grid-row";
import CustomerCareNavigation from "./main/CustomerCareNavigation";
import CustomerCareContent from "./main/CustomerCareContent";
import Image from "@/components/common/image/image";
// import { CustomerCareProps } from "@/types/customer-care";

// const CustomerCarePage = ({ data }: CustomerCareProps) => {

const CustomerCarePage = t0 => {
  const $ = _c(40);
  const {
    data
  } = t0;
  const [activeSection, setActiveSection] = useState("");
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== data.sections) {
    t1 = data.sections?.map(_temp) || [];
    $[0] = data.sections;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const navigationItems = t1;
  let t2;
  if ($[2] !== navigationItems) {
    t2 = () => {
      if (navigationItems.length === 0) {
        return;
      }
      const visibleSection = navigationItems.find(_temp2);
      setActiveSection(visibleSection?.id || navigationItems[0].id);
    };
    $[2] = navigationItems;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = sectionId => {
      const element = document.getElementById(sectionId);
      if (!element) {
        return;
      }
      element.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
      setActiveSection(sectionId);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const scrollToSection = t4;
  let t5;
  let t6;
  if ($[6] !== data.sections) {
    t5 = () => {
      const observer = new IntersectionObserver(entries => {
        let closestEntry = null;
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!closestEntry || entry.boundingClientRect.top < closestEntry.boundingClientRect.top) {
              closestEntry = entry;
            }
          }
        });
        if (closestEntry) {
          setActiveSection(closestEntry?.target?.id);
        }
      }, {
        threshold: 0.1,
        rootMargin: "0px 0px -50% 0px"
      });
      data.sections?.forEach(section_0 => {
        const element_0 = document.getElementById(section_0._key);
        if (element_0) {
          observer.observe(element_0);
        }
      });
      return () => {
        observer.disconnect();
      };
    };
    t6 = [data.sections];
    $[6] = data.sections;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== open) {
    t7 = () => setOpen(!open);
    $[9] = open;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== activeSection || $[12] !== navigationItems) {
    t8 = navigationItems.find(s => s.id === activeSection)?.title;
    $[11] = activeSection;
    $[12] = navigationItems;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <button type="button" onClick={t7} className="w-full rounded-md border border-[#4A4A4A] bg-white px-4 py-3 pr-10 text-left text-[#373A36]">{t8}</button>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"><Image src="/down-arrow.svg" alt="dropdown arrow" width={24} height={24} /></div>;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== activeSection || $[19] !== navigationItems || $[20] !== open) {
    t11 = open && <ul className="absolute z-10 mt-1 max-h-60 w-full overflow-y-auto rounded-md border border-[#ddd] bg-white shadow">{navigationItems.map(s_0 => <li key={s_0.id} onClick={() => {
        setOpen(false);
        scrollToSection(s_0.id);
      }} className={`cursor-pointer whitespace-normal break-words px-4 py-2 text-[#373A36] ${activeSection === s_0.id ? "font-semibold" : ""}`}>{s_0.title}</li>)}</ul>;
    $[18] = activeSection;
    $[19] = navigationItems;
    $[20] = open;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <div className="sticky top-0 z-20 lg:hidden"><div className="relative w-full lg:hidden">{t9}{t10}{t11}</div></div>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== activeSection || $[26] !== navigationItems) {
    t13 = <div className="lg:w-[280px] lg:flex-shrink-0"><CustomerCareNavigation items={navigationItems} activeSection={activeSection} onSectionClick={scrollToSection} /></div>;
    $[25] = activeSection;
    $[26] = navigationItems;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== data.sections) {
    t14 = data.sections || [];
    $[28] = data.sections;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== data.title || $[31] !== navigationItems || $[32] !== t14) {
    t15 = <div className="min-w-0 flex-1"><CustomerCareContent intro={data.title} sections={t14} navigationItems={navigationItems} onSectionClick={scrollToSection} /></div>;
    $[30] = data.title;
    $[31] = navigationItems;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t15) {
    t16 = <div className="flex flex-col gap-6 lg:flex-row lg:gap-8">{t13}{t15}</div>;
    $[34] = t13;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t16) {
    t17 = <div className="py-5 text-[#373a36]"><GridRow><GridColumn className="lg:mt-15 mx-auto mt-1 px-4 md:mt-10">{t12}{t16}</GridColumn></GridRow></div>;
    $[37] = t12;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
};

// Helper function
function getSectionTitle(section: any): string {
  switch (section._type) {
    case "contactPanel":
      return section.heading || "Contact";
    case "servicingPanel":
      return section.heading || "Servicing";
    case "mediaInquiries":
      return section.heading || "Media Inquiries";
    case "stateNotice":
      return `${section.state || "State"}`;
    case "legalCallout":
      return "Legal Notice";
    default:
      return "Section";
  }
}
export default CustomerCarePage;
function _temp(section) {
  return {
    id: section._key,
    title: getSectionTitle(section),
    type: section._type
  };
}
function _temp2(item) {
  const el = document.getElementById(item.id);
  if (!el) {
    return false;
  }
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.top < window.innerHeight / 2;
}